import { ReactComponent as Spin } from "src/assets/svg/spinner.svg";

const Spinner = ({ className = "" }: { className?: string }) => {
  return <Spin className={"mx-auto animate-spin " + className} />;
};

export default Spinner;
